/* Gentle Beauty — core runtime (window.GB). No dependencies. Loaded with defer. */
(function () {
  'use strict';
  if (window.GB && window.GB.__ready) return;

  var cfg = window.GBConfig || {};
  var GB = (window.GB = window.GB || {});
  GB.__ready = true;
  GB.config = cfg;

  /* ---------- Utils ---------- */
  GB.$ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  GB.$$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };
  GB.debounce = function (fn, wait) {
    var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait || 200); };
  };
  GB.store = {
    get: function (key, fallback) { try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : fallback; } catch (e) { return fallback; } },
    set: function (key, val) { try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {} }
  };
  GB.emit = function (name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail })); };
  GB.formatMoney = function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '', placeholder = /\{\{\s*(\w+)\s*\}\}/, fmt = format || cfg.moneyFormat || '${{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100.0).toFixed(precision);
      var parts = n.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands), c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = fmt.match(placeholder); if (!m) return fmt;
    switch (m[1]) {
      case 'amount': value = withDelims(cents, 2); break;
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2);
    }
    return fmt.replace(placeholder, value);
  };
  GB.fetchSection = function (url, sectionId) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); });
  };
  GB.escape = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- Toast ---------- */
  GB.toast = function (message, opts) {
    opts = opts || {};
    var wrap = GB.$('.gb-toast-wrap');
    if (!wrap) { wrap = document.createElement('div'); wrap.className = 'gb-toast-wrap'; wrap.setAttribute('aria-live', 'polite'); document.body.appendChild(wrap); }
    var el = document.createElement('div');
    el.className = 'gb-toast';
    el.innerHTML = '<span>' + GB.escape(message) + '</span>' + (opts.link ? '<a href="' + GB.escape(opts.link) + '">' + GB.escape(opts.linkLabel || 'View') + '</a>' : '');
    wrap.appendChild(el);
    setTimeout(function () { el.classList.add('is-leaving'); setTimeout(function () { el.remove(); }, 450); }, opts.duration || 3200);
  };

  /* ---------- Body lock + drawers ---------- */
  var openDrawers = 0;
  GB.lock = function () { openDrawers++; document.body.classList.add('gb-lock'); };
  GB.unlock = function () { openDrawers = Math.max(0, openDrawers - 1); if (!openDrawers) document.body.classList.remove('gb-lock'); };
  GB.openDrawer = function (el, trigger) {
    if (typeof el === 'string') el = document.getElementById(el);
    if (!el || el.classList.contains('is-open')) return;
    el.__trigger = trigger || document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); GB.lock();
    var focusable = el.querySelector('[autofocus], input, button, [href], [tabindex]:not([tabindex="-1"])');
    setTimeout(function () { focusable && focusable.focus({ preventScroll: true }); }, 60);
    GB.emit('gb:drawer:open', { id: el.id });
  };
  GB.closeDrawer = function (el) {
    if (typeof el === 'string') el = document.getElementById(el);
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); GB.unlock();
    el.__trigger && el.__trigger.focus && el.__trigger.focus({ preventScroll: true });
    GB.emit('gb:drawer:close', { id: el.id });
  };
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-gb-drawer-open]');
    if (open) { e.preventDefault(); GB.openDrawer(open.getAttribute('data-gb-drawer-open'), open); return; }
    var close = e.target.closest('[data-gb-drawer-close]');
    if (close) { e.preventDefault(); GB.closeDrawer(close.closest('.gb-drawer')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var d = GB.$$('.gb-drawer.is-open').pop(); d && GB.closeDrawer(d);
  });

  /* ---------- Wishlist ---------- */
  var WKEY = 'gb:wishlist';
  GB.wishlist = {
    enabled: cfg.wishlistEnabled !== false,
    all: function () { return GB.store.get(WKEY, []); },
    has: function (handle) { return this.all().indexOf(handle) > -1; },
    add: function (handle) { var l = this.all(); if (l.indexOf(handle) < 0) { l.unshift(handle); GB.store.set(WKEY, l.slice(0, 100)); } this.sync(); GB.emit('gb:wishlist:change', { handle: handle, action: 'add', items: this.all() }); },
    remove: function (handle) { GB.store.set(WKEY, this.all().filter(function (h) { return h !== handle; })); this.sync(); GB.emit('gb:wishlist:change', { handle: handle, action: 'remove', items: this.all() }); },
    toggle: function (handle) { if (this.has(handle)) { this.remove(handle); return false; } this.add(handle); return true; },
    clear: function () { GB.store.set(WKEY, []); this.sync(); GB.emit('gb:wishlist:change', { action: 'clear', items: [] }); },
    sync: function () {
      var items = this.all();
      GB.$$('[data-gb-wishlist-toggle]').forEach(function (btn) {
        var on = items.indexOf(btn.getAttribute('data-handle')) > -1;
        btn.classList.toggle('is-active', on); btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      GB.$$('[data-gb-wishlist-count]').forEach(function (el) { el.textContent = items.length || ''; el.setAttribute('data-count', items.length); });
    }
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gb-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var added = GB.wishlist.toggle(btn.getAttribute('data-handle'));
    GB.toast(added ? (cfg.wishlistAdded || 'Saved to your wishlist') : (cfg.wishlistRemoved || 'Removed from your wishlist'), added && cfg.wishlistUrl ? { link: cfg.wishlistUrl, linkLabel: cfg.wishlistView || 'View' } : {});
  });

  /* ---------- Recently viewed ---------- */
  GB.recent = {
    all: function () { return GB.store.get('gb:recent', []); },
    push: function (handle) { if (!handle) return; var l = this.all().filter(function (h) { return h !== handle; }); l.unshift(handle); GB.store.set('gb:recent', l.slice(0, 12)); }
  };

  /* ---------- Cart ---------- */
  GB.cart = {
    sections: function () {
      var ids = [];
      if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
      if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
      if (document.querySelector('cart-notification')) ids.push('cart-notification-product', 'cart-notification-button');
      return ids;
    },
    add: function (items, trigger) {
      if (!Array.isArray(items)) items = [items];
      var body = { items: items.map(function (i) { return { id: Number(i.id), quantity: Number(i.quantity || 1), properties: i.properties || undefined }; }) };
      var sections = this.sections();
      if (sections.length) { body.sections = sections.join(','); body.sections_url = window.location.pathname; }
      trigger && trigger.classList.add('is-loading');
      return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          trigger && trigger.classList.remove('is-loading');
          if (res.status && res.status !== 200) { GB.toast(res.description || res.message || 'Could not add to bag'); throw res; }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && res.sections && typeof drawer.renderContents === 'function') {
            res.id = res.items && res.items[0] ? res.items[0].id : null;
            drawer.renderContents(res);
          } else if (!drawer) {
            GB.toast(cfg.addedToCart || 'Added to your bag', { link: (window.routes && window.routes.cart_url) || '/cart', linkLabel: cfg.viewCart || 'View bag' });
            GB.cart.refreshCount();
          }
          GB.emit('gb:cart:added', res);
          if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'gb', cartData: res });
          return res;
        })
        .catch(function (err) { trigger && trigger.classList.remove('is-loading'); throw err; });
    },
    refreshCount: function () {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        GB.$$('[data-gb-cart-count]').forEach(function (el) { el.textContent = c.item_count || ''; el.setAttribute('data-count', c.item_count); });
      });
    }
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gb-add]');
    if (!btn) return;
    e.preventDefault();
    GB.cart.add({ id: btn.getAttribute('data-gb-add'), quantity: btn.getAttribute('data-quantity') || 1 }, btn).catch(function () {});
  });

  /* ---------- Quick view (sections/gb-quick-view.liquid) ---------- */
  GB.quickView = function (url, trigger) {
    var drawer = document.getElementById('GBQuickView');
    if (!drawer) { window.location.href = url; return; }
    var body = drawer.querySelector('[data-gb-quick-view-body]');
    body.innerHTML = '<div class="gb-skeleton" style="aspect-ratio:4/3"></div>';
    GB.openDrawer(drawer, trigger);
    GB.fetchSection(url, 'gb-quick-view').then(function (doc) {
      var content = doc.querySelector('[data-gb-quick-view-content]');
      body.innerHTML = content ? content.outerHTML : '';
      GB.$$('script', body).forEach(function (old) { var s = document.createElement('script'); s.textContent = old.textContent; old.replaceWith(s); });
      GB.wishlist.sync();
      GB.emit('gb:quickview:loaded', { url: url, el: body });
    }).catch(function () { window.location.href = url; });
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gb-quick-view]');
    if (!btn) return;
    e.preventDefault();
    GB.quickView(btn.getAttribute('data-gb-quick-view'), btn);
  });

  /* ---------- Swatch hover image swap on cards ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.gb-card [data-gb-swatch-image]');
    if (!sw) return;
    e.preventDefault();
    var card = sw.closest('.gb-card'), img = card && card.querySelector('.gb-card__img--main');
    if (img && sw.dataset.gbSwatchImage) { img.srcset = ''; img.src = sw.dataset.gbSwatchImage; }
    GB.$$('.gb-swatch', card).forEach(function (s) { s.classList.toggle('is-active', s === sw); });
    if (sw.dataset.variantUrl) { var a = card.querySelector('.gb-card__title a'); a && (a.href = sw.dataset.variantUrl); }
  });

  /* ---------- Reveal on scroll ---------- */
  GB.reveal = function (root) {
    var els = GB.$$('[data-gb-reveal]:not(.is-visible), .gb-illustration--draw:not(.is-visible)', root);
    var animate = document.documentElement.classList.contains('gb-animate') && 'IntersectionObserver' in window && !(window.Shopify && Shopify.designMode);
    if (!animate) { els.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var io = GB.__revealIO || (GB.__revealIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-visible'); GB.__revealIO.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }));
    /* Never hide content that is already on screen (protects LCP / CLS); only arm below-the-fold elements.
       Read all positions first, then write classes, to avoid layout thrashing. */
    var tops = els.map(function (el) { return el.getBoundingClientRect().top; });
    els.forEach(function (el, i) {
      if (tops[i] < vh * 0.92) { el.classList.add('is-visible'); return; }
      el.classList.add('gb-armed');
      io.observe(el);
    });
  };

  /* ---------- Lazy videos: <video data-gb-lazy-video> with <source data-src> ---------- */
  GB.lazyVideos = function (root) {
    var vids = GB.$$('video[data-gb-lazy-video]:not([data-loaded])', root);
    if (!vids.length) return;
    var load = function (v) {
      GB.$$('source[data-src]', v).forEach(function (s) { s.src = s.getAttribute('data-src'); });
      if (v.getAttribute('data-src')) v.src = v.getAttribute('data-src');
      v.setAttribute('data-loaded', ''); v.load();
      if (v.hasAttribute('data-autoplay')) { var p = v.play(); p && p.catch(function () {}); }
    };
    if (!('IntersectionObserver' in window) || cfg.lazyVideos === false) { vids.forEach(load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { load(en.target); io.unobserve(en.target); } });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  };

  /* ---------- Image fade-in ---------- */
  GB.lazyImages = function (root) {
    GB.$$('img.gb-lazy:not(.is-loaded)', root).forEach(function (img) {
      if (img.complete && img.naturalWidth) img.classList.add('is-loaded');
      else img.addEventListener('load', function () { img.classList.add('is-loaded'); }, { once: true });
    });
  };

  /* ---------- Instant page (prefetch on hover) ---------- */
  function instantPage() {
    if (!cfg.instantPage || !('IntersectionObserver' in window)) return;
    var conn = navigator.connection; if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;
    var done = {};
    document.addEventListener('mouseover', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || a.origin !== location.origin || done[a.href] || a.hasAttribute('data-no-instant') || /\/(cart|checkout|account)/.test(a.pathname) || a.href.indexOf('#') > -1) return;
      done[a.href] = true;
      var l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
    }, { passive: true });
  }

  /* ---------- Tabs: [data-gb-tabs] > [role=tab][aria-controls] ---------- */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-gb-tabs] [role="tab"]');
    if (!tab) return;
    var root = tab.closest('[data-gb-tabs]');
    GB.$$('[role="tab"]', root).forEach(function (t) {
      var on = t === tab; t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
      var panel = document.getElementById(t.getAttribute('aria-controls')); if (panel) panel.hidden = !on;
    });
    GB.emit('gb:tab:change', { root: root, tab: tab });
  });

  /* ---------- Scroll sliders: [data-gb-slider] with [data-gb-prev]/[data-gb-next] and .gb-progress__bar ---------- */
  GB.sliders = function (root) {
    GB.$$('[data-gb-slider-root]:not([data-init])', root).forEach(function (wrap) {
      wrap.setAttribute('data-init', '');
      var track = wrap.querySelector('[data-gb-slider]'); if (!track) return;
      var prev = wrap.querySelector('[data-gb-prev]'), next = wrap.querySelector('[data-gb-next]'), bar = wrap.querySelector('.gb-progress__bar');
      var step = function () { var c = track.children[0]; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 16) : track.clientWidth; };
      var update = function () {
        var max = track.scrollWidth - track.clientWidth;
        var ratio = max > 0 ? track.scrollLeft / max : 1;
        if (bar) { var w = Math.max(12, (track.clientWidth / track.scrollWidth) * 100); bar.style.width = w + '%'; bar.style.transform = 'translateX(' + (ratio * (100 / w * 100 - 100)) + '%)'; }
        if (prev) prev.disabled = track.scrollLeft < 4;
        if (next) next.disabled = track.scrollLeft > max - 4;
      };
      prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', GB.debounce(update, 30), { passive: true });
      window.addEventListener('resize', GB.debounce(update, 120));
      update();
    });
  };

  GB.init = function (root) {
    GB.reveal(root); GB.lazyVideos(root); GB.lazyImages(root); GB.sliders(root); GB.wishlist.sync();
  };

  function boot() {
    GB.init(document);
    instantPage();
    if (cfg.productHandle) GB.recent.push(cfg.productHandle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  document.addEventListener('shopify:section:load', function (e) { GB.init(e.target); });
  document.addEventListener('shopify:block:select', function (e) { GB.init(e.target.closest('.shopify-section') || document); });
})();


/* ---------- Back in stock: [data-gb-notify] opens #GBNotify ---------- */
(function () {
  function modalForm(modal) { return modal.querySelector('.gb-notify__form'); }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gb-notify]');
    if (!btn) return;
    var modal = document.getElementById('GBNotify');
    if (!modal) return;
    e.preventDefault();
    var form = modalForm(modal);
    var vt = btn.dataset.variantTitle;
    var name = (btn.dataset.productTitle || '') + (vt && vt !== 'Default Title' ? ' – ' + vt : '');
    modal.querySelector('[data-gb-notify-name]').textContent = name;
    var img = modal.querySelector('[data-gb-notify-img]');
    if (btn.dataset.productImage) { img.src = btn.dataset.productImage; img.alt = btn.dataset.productTitle || ''; }
    form.querySelector('[data-gb-notify-field="product"]').value = name;
    form.querySelector('[data-gb-notify-field="variant"]').value = btn.dataset.variantId || '';
    form.querySelector('[data-gb-notify-field="url"]').value = btn.dataset.productUrl || '';
    form.classList.remove('is-done');
    form.querySelector('[data-gb-notify-success]').hidden = true;
    form.querySelector('[data-gb-notify-error]').hidden = true;
    if (window.GB) GB.openDrawer(modal, btn);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#GBNotify .gb-notify__form');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var ok = form.querySelector('[data-gb-notify-success]');
    var err = form.querySelector('[data-gb-notify-error]');
    var submit = form.querySelector('[type="submit"]');
    var email = form.querySelector('[type="email"]');
    if (!email.value || !email.checkValidity()) { err.hidden = false; return; }
    if (submit) submit.classList.add('is-loading');
    fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' })
      .then(function (r) { return r.text().then(function (t) { return { url: r.url, text: t, ok: r.ok }; }); })
      .then(function (res) {
        if (submit) submit.classList.remove('is-loading');
        if (res.url.indexOf('/challenge') > -1) { form.submit(); return; }
        var posted = res.url.indexOf('contact_posted=true') > -1 || (res.ok && res.text.indexOf('form-status--error') < 0);
        if (!posted) { err.hidden = false; return; }
        ok.hidden = false; err.hidden = true; form.classList.add('is-done');
      })
      .catch(function () { if (submit) submit.classList.remove('is-loading'); err.hidden = false; });
  });
})();
